import React from 'react';
import styled from 'styled-components';
import { useObserver } from 'mobx-react-lite';

import useClickOut from 'shared/hooks/use-click-out';
import useTranslation from 'hooks/use-translation';
import useUser from 'hooks/use-user';

import { DesktopOnly, MobileOnly, Clickable } from 'shared/components';
import { Button } from 'components/core';
import AccountIcon from 'assets/account-icon';
import MyAccountPopover from 'components/global-header/my-account-link/my-account-popover';
import MyAccountDrawer from 'components/global-header/my-account-link/my-account-drawer';
import ChevronIcon from 'assets/chevron-icon';

export function MyAccountLink({ displayAccountIcon = true, isOnLight = false }) {
  const { t } = useTranslation();
  const user = useUser();
  const isLoggedIn = useObserver(() => user?.isLoggedIn);

  const [ref, showDropdown, setShowDropdown] = useClickOut();
  const toggleDropdown = () => setShowDropdown(!showDropdown);

  return (
    <Account ref={ref} onClick={toggleDropdown} isOnLight={isOnLight}>
      {displayAccountIcon && <AccountIcon />}
      <ButtonWrapper>
        <ButtonContent>
          {t('common.myAccount', 'My account')} <ChevronIcon width={10} height={10} />
        </ButtonContent>
      </ButtonWrapper>

      {showDropdown && (
        <React.Fragment>
          <DesktopOnly>
            <MyAccountPopover isLoggedIn={isLoggedIn} toggleDropdown={toggleDropdown} anchorEL={ref.current} />
          </DesktopOnly>

          <MobileOnly display='block'>{!isLoggedIn && <MyAccountPopover anchorEL={ref.current} />}</MobileOnly>
        </React.Fragment>
      )}
      <MobileOnly>
        <MyAccountDrawer open={showDropdown && isLoggedIn} />
      </MobileOnly>
    </Account>
  );
}

const Account = styled(Clickable)`
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  height: 100%;
  margin-right: 26px;
  padding-left: 6px;

  &&& {
    color: ${({ theme, isOnLight }) => (isOnLight ? theme.colors.black : theme.colors.green[95])};
  }

  svg {
    margin-right: 9px;
    margin-left: 5px;
  }
`;

const ButtonWrapper = styled(Button)`
  border: 1px solid ${({ theme }) => theme.colors.white};
  box-sizing: border-box;
  border-radius: 36px;
  font-size: 14px !important;
  line-height: 175%;
  min-width: 106px;
  text-transform: none;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.white} !important;
  background: transparent;
  color: var(--button-color);
  background: transparent;
  border: 1px solid var(--button-color);
  height: 50px;
  text-transform: none;
  font-size: 16px;
`;

const ButtonContent = styled.span`
  padding-left: 15px;
  padding-right: 11px;
`;
